export default {
  MXN: {
    rate: 100,
    symbol: 'MX$'
  },
  CNY: {
    rate: 100,
    symbol: '￥'
  },
  BRL: {
    rate: 100,
    symbol: 'R$'
  },
  '': {
    rate: 100,
    symbol: '$'
  }
}
